module.exports = __webpack_public_path__ + "img/Mark.73e1fb5b.svg";